import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { DatasourceDownstreamFlowsQuery, DatasourceDownstreamFlowsQueryVariables, DownstreamFlowsFilteredByFieldQuery, DownstreamFlowsFilteredByFieldQueryVariables, FlowsDisplayGridRowDataFragment, FlowSortOrder , DatasourceDownstreamFlowsDocument , DownstreamFlowsFilteredByFieldDocument } from '../../../../../gen-src/queries';
import { ConnectionListResult, GridSortProps, PaginatedQueryWrapper } from '../../../data-catalog-shared';
import {
  FlowsDisplayGrid,
  FlowsDisplayGridRowData,
  getRowDataForFlow,
} from '../sharedDisplayGrid/FlowsDisplayGrid';
import { FlowsValidSortFields } from '../sorting/sortProviders/FlowsGridSortProvider';

type QueryVariables = DatasourceDownstreamFlowsQueryVariables;
type QueryResults = DatasourceDownstreamFlowsQuery;
type QueryResultListNode = FlowsDisplayGridRowDataFragment;
type GridRowData = FlowsDisplayGridRowData;

type QueryVariablesWithFilter = DownstreamFlowsFilteredByFieldQueryVariables;
type QueryResultsWithFilter = DownstreamFlowsFilteredByFieldQuery;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return (
    resultData &&
    resultData.publishedDatasources &&
    resultData.publishedDatasources[0] &&
    resultData.publishedDatasources[0].downstreamFlowsConnection
  );
}


function selectConnectionListResultForFilteredQuery(resultData: QueryResultsWithFilter): ConnectionListResult<QueryResultListNode> | null {
  return (
    resultData &&
    resultData.fieldsConnection &&
    resultData.fieldsConnection.nodes &&
    resultData.fieldsConnection.nodes[0] &&
    resultData.fieldsConnection.nodes[0].downstreamFlowsConnection
  );
}

export type DatasourceDownstreamFlowsQueryGridProps = GridSortProps<FlowsValidSortFields> & {
  readonly vizportalUrlId: string;
  readonly filteredFieldId: string | null;
  readonly rowCount: number | null;
};

export function DatasourceDownstreamFlowsQueryGrid(props: DatasourceDownstreamFlowsQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyDownstreamFlowsLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyDownstreamFilteredFlowsLineageGridMessage();

  return (
    props.filteredFieldId ? (
      // Query with Selected Field as Filter
      <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNode, GridRowData>
        queryGql={DownstreamFlowsFilteredByFieldDocument}
        partialQueryVariables={{ selectedFieldId: props.filteredFieldId, orderBy: props.orderBy as FlowSortOrder }}
        selectConnectionListResult={selectConnectionListResultForFilteredQuery}
        mapResultNode={getRowDataForFlow}
      >
        {({ rowStore }) => (
          <FlowsDisplayGrid
            rowStore={rowStore}
            emptyGridMessage={emptyFilteredGridMessage}
            rowCount={props.rowCount}
            orderBy={props.orderBy}
            updateSortOrder={props.updateSortOrder}
          />
        )}
      </PaginatedQueryWrapper>
    ) : (
      // Query without Selection
      <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
        queryGql={DatasourceDownstreamFlowsDocument}
        partialQueryVariables={{ vizportalUrlId: props.vizportalUrlId, orderBy: props.orderBy as FlowSortOrder }}
        selectConnectionListResult={selectConnectionListResult}
        mapResultNode={getRowDataForFlow}
      >
        {({ rowStore }) => (
          <FlowsDisplayGrid
            rowStore={rowStore}
            emptyGridMessage={emptyGridMessage}
            rowCount={props.rowCount}
            orderBy={props.orderBy}
            updateSortOrder={props.updateSortOrder}
          />
        )}
      </PaginatedQueryWrapper>
    )
  )
}
